import { createBrowserRouter } from 'react-router-dom';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import ShareRoutes from './ShareRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([LoginRoutes, ShareRoutes, MainRoutes], { basename: import.meta.env.VITE_APP_BASE_NAME });

export default router;
